<template>
    <div class="upload-control-wrap" v-loading.body="loading">
        <el-radio-group class="upload-type-radio" v-model="uploadType" size="small">
            <el-radio label="drag" border>拖拽上传</el-radio>
            <el-radio label="cropper" border>裁剪上传</el-radio>
        </el-radio-group>
        <cropperUpload
            v-if="uploadType === 'cropper'"
            @upload-handler="cropperUploadHandler"
        />
        <dragUpload
            v-if="uploadType === 'drag'"
            @upload-handler="dragUploadHandler"
            :hintMsg="uploadHint"
            :multiple="multiple"
        />
        <!-- <el-form class="res-form" ref="form" label-width="80px">
            <el-form-item label="原图：" prop="">
                <el-input type="textarea" class="res-url" v-model="imageUrl" placeholder="原图片链接地址" readonly></el-input>
            </el-form-item>
            <el-form-item label="略缩图：" prop="">
                <el-input type="textarea" class="res-url" v-model="thumbUrl" placeholder="略缩图片链接地址" readonly></el-input>
            </el-form-item>
        </el-form> -->
    </div>
</template>
<script>
import moment from 'moment';
import cropperUpload from './cropperUpload';
import dragUpload from './dragUpload';
import apiPath from '@/service/apiPath.js';
import { requestApi } from '@/service/requestApi.js';
import Vue from 'vue';

export default {
    props: {
        // name: String
        multiple: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            loading: false,
            uploadHint: '只能上传jpg/png/gif文件，且jpg/png不超过500kb,gif不超过3mb',
            uploadType: 'drag',
            imageUrl: '',
            thumbUrl: ''
        }
    },
    components: {
        cropperUpload,
        dragUpload
    },
    methods: {
        initData(row) {
            this.imageUrl = row.image_url;
            this.thumbUrl = row.thumb_url;
        },
        dragUploadHandler(file) {
            let formData = new FormData();
            if (file.type.search('png') === -1
                && file.type.search('jpg') === -1
                && file.type.search('jpeg') === -1
                && file.type.search('gif') === -1) {
                this.$message({
                    type: 'warning',
                    message: `只能上传jpg/png/gif文件`,
                    duration: 1500
                });
                return;
            }
            if (file.size > 1024 * 500 && file.type.search('gif') === -1) {
                this.$message({
                    type: 'warning',
                    message: `jpg/png文件体积不能超过500kb`,
                    duration: 1500
                });
                return;
            } else if (file.size > 1024 * 1024 * 3 && file.type.search('gif') !== -1) {
                this.$message({
                    type: 'warning',
                    message: `gif文件体积不能超过3mb`,
                    duration: 1500
                });
                return;
            }

            formData.append('file', file);
            // 自定义上传
            this.loading = true;
            requestApi({
                method: 'post',
                url: apiPath.UPLOAD_FILES,
                body: formData,
                options: {
                    params: {
                        action: 'commonupload'
                    }
                },
                successFn: (data) => {
                    this.$message({
                        type: 'success',
                        message: `图片上传成功`,
                        duration: 1500
                    });
                    this.imageUrl = Vue.filter('url-proto')(data.url);
                    this.thumbUrl = Vue.filter('url-proto')(data.thumb_url);
                    this.$emit('image-uploaded', {
                        imageUrl: this.imageUrl,
                        thumbUrl: this.thumbUrl
                    });
                }
            }).then((data) => {
                this.loading = false;
            });
        },
        cropperUploadHandler(blob) {
            let formData = new FormData();
            formData.append('file', blob);
            formData.append('file_name', `blob_${moment().unix()}.jpg`);
            requestApi({
                method: 'post',
                url: apiPath.UPLOAD_FILES,
                options: {
                    params: {
                        action: 'commonupload'
                    }
                },
                body: formData,
                successFn: (data) => {
                    this.$message({
                        type: 'success',
                        message: `图片上传成功`,
                        duration: 1500
                    });
                    this.imageUrl = Vue.filter('url-proto')(data.url);
                    this.thumbUrl = Vue.filter('url-proto')(data.thumb_url);
                    this.$emit('image-uploaded', {
                        imageUrl: this.imageUrl,
                        thumbUrl: this.thumbUrl
                    });
                }
            }).then((data) => {
                this.loading = false;
            });
        },
    },
    computed: {
    }
}
</script>
<style lang="less" scoped>
    .upload-control-wrap {
        .upload-type-radio {
            padding: 10px 0;
            .el-radio {
                background-color: #fff;
            }
        }
        .res-form {
            .el-form-item {
                margin-bottom: 10px;
            }
        }
        // .res-url {
        //     margin: 10px 0;
        // }
    }

</style>



// WEBPACK FOOTER //
// src/components/uploadImage/index.vue